import CardSystem from '../CardSystem';
import GameObject from '../../../GameObject/GameObject';
import Animator from '../../../Prototype/Animator';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { RemoveCardsPreBooster } from 'System/Animation/Clip/RemoveCardsPreBooster';


export default function RemoveThreePreBoosterAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    const animator = GameObject.Instantiate(Animator);
    system.animator.addChildAt(animator, 0);

    taskData.cards.forEach((cardId) => {
        const card = system.getCardByID(cardId);
        animator.addChildAt(card, 0);
    });

    system.taskQueue.queue(new AnimationClipTask(new RemoveCardsPreBooster(animator, {
        system, cardsData: taskData.cardsData
    })));
}
